
import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import Char3D from './char3D.js';
import './App.css';
function App() {
    return (
        <Router>
            <div>
                {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
                <Switch>
                    <Route path="/">
                        <Char3D />
                    </Route>
                </Switch>

            </div>
        </Router>
    );
}

export default App;
